import { _IDeliveryStatus, IDeliveryNormalized } from '@data/types'

import {
  deliveryStatusClassification,
  GroupDeliveriesForDashboard,
} from './group-deliveries-by-status.type'

const isPending = (status: _IDeliveryStatus) =>
  status === _IDeliveryStatus.processed ||
  status === _IDeliveryStatus.pre_processed
const isProcessing = (status: _IDeliveryStatus) =>
  status === _IDeliveryStatus.picking || status === _IDeliveryStatus.picked
const isReady = (status: _IDeliveryStatus) => status === _IDeliveryStatus.ready
const isOutForDelivery = (status: _IDeliveryStatus) =>
  status === _IDeliveryStatus.on_the_way || status === _IDeliveryStatus.arrived

export const groupDeliveriesByStatus = (
  deliveries: IDeliveryNormalized[] = []
): GroupDeliveriesForDashboard => {
  const groupedDeliveries: GroupDeliveriesForDashboard = {
    [deliveryStatusClassification.outForDelivery]: [],
    [deliveryStatusClassification.ready]: [],
    [deliveryStatusClassification.processing]: [],
    [deliveryStatusClassification.pending]: [],
    [deliveryStatusClassification.unknown]: [],
  }

  deliveries.forEach((delivery: IDeliveryNormalized) => {
    const { status } = delivery

    if (isPending(status)) {
      groupedDeliveries.pending.push(delivery)
    } else if (isProcessing(status)) {
      groupedDeliveries.processing.push(delivery)
    } else if (isReady(status)) {
      groupedDeliveries.ready.push(delivery)
    } else if (isOutForDelivery(status)) {
      groupedDeliveries.outForDelivery.push(delivery)
    } else {
      groupedDeliveries.unknown.push(delivery)
    }
  })

  return groupedDeliveries
}

export const groupDeliveryByStatus = (
  delivery: IDeliveryNormalized | null
): deliveryStatusClassification => {
  if (!delivery) return deliveryStatusClassification.unknown

  const { status } = delivery

  if (isPending(status)) {
    return deliveryStatusClassification.pending
  } else if (isProcessing(status)) {
    return deliveryStatusClassification.processing
  } else if (isReady(status)) {
    return deliveryStatusClassification.ready
  } else if (isOutForDelivery(status)) {
    return deliveryStatusClassification.outForDelivery
  }

  return deliveryStatusClassification.unknown
}
